import React from 'react';

import MessageContent from '../messages/MessageContent';

function MessagesPanel({ message, metadata, loading }) {
  return (
    <div className="glass container panel-fit messages-panel" style={{ flex: 2 }}>
      <h1>הודעות</h1>
      <div className="container panel-content messages-content">
        <div className="panel-item panel-item--message">
          <MessageContent message={loading && message?.type === 'empty' ? { type: 'loading' } : message} metadata={metadata} />
        </div>
      </div>
    </div>
  );
}

export default React.memo(MessagesPanel);
